import React from 'react'

export default function HiringTypeCheckbox({ hiringTypeChange, filter, hiringType }) {
    const isSelected2 = (id) => {
        return hiringType?.some((post) => post.id == id);
    };
    return (
        <div>
            <>
                <h6>{filter?.title}</h6>
                {filter.values.map((value) => (
                    <div className="input-check" key={value.id}>
                        <input
                            type="checkbox"
                            className="form-control"
                            checked={isSelected2(value.id)}
                            onChange={() => hiringTypeChange(value)}
                        />
                        <span>{value.title}</span>
                    </div>
                ))}
            </>
        </div>
    )
}
